import {Component} from 'react'
import Paginator from 'paginator'
import Link from './links/RouterLink'

let PaginationLink = (props) => {
    return (
        <li className={props.active ? 'active' : ''}>
            <Link route={props.routeParams.route} params={props.routeParams.params}>
                {props.text}
            </Link>
        </li>
    )
}

/**
 *
 */
class Pagination extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let paginator = new Paginator(this.props.itemsCountPerPage, 7),
            {first_page, last_page, total_pages} = paginator.build(this.props.totalItems, this.props.activePage),
            links = [],
            activePage = this.props.activePage;

        if (this.props.totalItems > this.props.itemsCountPerPage) {
            links.push(<PaginationLink className="first-page" routeParams={this.props.pageParams(1)}
                                       text={this.props.firstPageText} key="first"/>)
        }

        if (last_page - first_page > 0) {
            for (let i = first_page; i <= last_page; i++) {
                links.push(<PaginationLink className={i} routeParams={this.props.pageParams(i)} text={i} key={i}
                                           active={i === activePage}/>)
            }
        }

        if (this.props.totalItems > this.props.itemsCountPerPage) {
            links.push(<PaginationLink className="last-page" routeParams={this.props.pageParams(total_pages)}
                                       text={this.props.lastPageText} key="last"/>)
        }

        return (
            <div className="pagination">
                <ul>{links}</ul>
            </div>
        )
    }
}
Pagination.defaultProps = {
    activePage: 1,
    itemsCountPerPage: 100,
    totalItems: null,
    getPageUrl: null, // function(page)
    pageRangeDisplayed: 5,
    firstPageText: "First",
    lastPageText: "Last"
}

export default Pagination



// WEBPACK FOOTER //
// components/Pagination.js